var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.0007 25.6673C20.444 25.6673 25.6673 20.444 25.6673 14.0007C25.6673 7.55733 20.444 2.33398 14.0007 2.33398C7.55733 2.33398 2.33398 7.55733 2.33398 14.0007C2.33398 20.444 7.55733 25.6673 14.0007 25.6673Z",
    fill: "#40196D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2366 13.9999L17.9199 11.3166C18.2583 10.9783 18.2583 10.4183 17.9199 10.0799C17.5816 9.74159 17.0216 9.74159 16.6833 10.0799L13.9999 12.7633L11.3166 10.0799C10.9783 9.74159 10.4183 9.74159 10.0799 10.0799C9.74159 10.4183 9.74159 10.9783 10.0799 11.3166L12.7633 13.9999L10.0799 16.6833C9.74159 17.0216 9.74159 17.5816 10.0799 17.9199C10.2549 18.0949 10.4766 18.1766 10.6983 18.1766C10.9199 18.1766 11.1416 18.0949 11.3166 17.9199L13.9999 15.2366L16.6833 17.9199C16.8583 18.0949 17.0799 18.1766 17.3016 18.1766C17.5233 18.1766 17.7449 18.0949 17.9199 17.9199C18.2583 17.5816 18.2583 17.0216 17.9199 16.6833L15.2366 13.9999Z",
    fill: "#40196D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.184bf477c7e445001a90864db3929244.svg";
export { ForwardRef as ReactComponent };